import axios, { AxiosError } from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';
import { t } from 'i18next';

const axiosInt = axios.create();

const axiosEndPoint = axios.create({
  baseURL: import.meta.env.VITE_END_POINT,
});

axiosEndPoint.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      axiosEndPoint.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    return request;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

const handleAxiosError = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const message = error.response?.data?.message;
    // Validation errors come back as a list of messages.
    if (Array.isArray(message)) return message.join('; ');
    return message || 'An unexpected error occurred';
  }
  return t('An unexpected error occurred');
};

// axiosInt.interceptors.response.use(
//   (response) => response,
//   (error) =>
//     Promise.reject(
//       (error.response && error.response.data) || 'There is an error!'
//     )
// );

export const mock = new AxiosMockAdapter(axiosInt, { delayResponse: 0 });

export default axiosInt;
export { axiosEndPoint, handleAxiosError };
